<div class="modal fade" id="kt_modal_negotiation_chat" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column w-100">
          <h2 class="fw-bold mb-3">Negotiation Chat</h2>

          <!-- Stock Details Header -->
          <div class="card bg-light-primary" *ngIf="selectedNegotiation">
            <div class="card-body p-4">
              <h3 class="fw-bold text-gray-800 mb-3">Stock Details</h3>
              <div class="row g-3">
                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <span class="text-muted fs-7 mb-1">Stock/Inventory No</span>
                    <span class="fw-semibold text-gray-800">{{ selectedNegotiation.car?.inventory_no || '-' }}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <span class="text-muted fs-7 mb-1">Car Name</span>
                    <span class="fw-semibold text-gray-800">{{ selectedNegotiation.car?.name || '-' }}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <span class="text-muted fs-7 mb-1">Make</span>
                    <span class="fw-semibold text-gray-800">{{ selectedNegotiation.car?.make_name || selectedNegotiation.car?.make || '-' }}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="d-flex flex-column">
                    <span class="text-muted fs-7 mb-1">Customer</span>
                    <span class="fw-semibold text-gray-800">{{ (selectedNegotiation.user?.title || '') + ' ' + (selectedNegotiation.user?.name || 'Unknown') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body p-0">
        <!-- Chat Container -->
        <div class="d-flex flex-column h-100" style="min-height: 500px;">

          <!-- Messages Area -->
          <div class="chat-messages flex-grow-1 p-5 overflow-auto" style="max-height: 500px;">

            <!-- Loading State -->
            <div class="text-center py-10" *ngIf="isLoadingMessages">
              <div class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                <span class="text-gray-600">Loading messages...</span>
              </div>
            </div>

            <!-- Empty State -->
            <div class="text-center py-10" *ngIf="!isLoadingMessages && messages.length === 0">
              <i class="ki-duotone ki-message-text-2 fs-3x text-gray-400 mb-3">
                <span class="path1"></span>
                <span class="path2"></span>
                <span class="path3"></span>
              </i>
              <p class="text-gray-600 fs-6">No messages yet. Start the conversation!</p>
            </div>

            <!-- Messages -->
            <div class="d-flex flex-column gap-5" *ngIf="!isLoadingMessages && messages.length > 0">
              <div *ngFor="let message of messages"
                   class="d-flex"
                   [ngClass]="isMyMessage(message) ? 'justify-content-end' : 'justify-content-start'">
                <div class="d-flex flex-column"
                     [ngClass]="isMyMessage(message) ? 'align-items-end' : 'align-items-start'"
                     style="max-width: 70%;">
                  <div class="d-flex align-items-center mb-2">
                    <span class="text-muted fs-7">
                      {{ isMyMessage(message) ? 'You' : ((message.user?.title || '') + ' ' + (message.user?.name || 'Unknown')) }}
                    </span>
                    <span class="text-muted fs-8 ms-2">{{ message.created_at | date:'short' }}</span>
                  </div>
                  <div class="p-4 rounded"
                       [ngClass]="isMyMessage(message) ? 'bg-primary text-white' : 'bg-light-info text-gray-800'">
                    <div class="mb-2" *ngIf="message.message">{{ message.message }}</div>

                    <!-- Attachments -->
                    <div class="d-flex flex-column gap-2" *ngIf="message.attachments && message.attachments.length > 0">
                      <div *ngFor="let attachment of message.attachments" class="attachment-item">
                        <a [href]="attachment" target="_blank"
                           class="d-flex align-items-center gap-2 text-decoration-none"
                           [ngClass]="isMyMessage(message) ? 'text-white' : 'text-primary'">
                          <i class="ki-duotone ki-file fs-3">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </i>
                          <span class="fs-7">View Attachment</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Message Input Area -->
          <div class="border-top p-5">

            <!-- Selected Files Preview -->
            <div class="mb-3" *ngIf="selectedFiles.length > 0">
              <div class="d-flex flex-wrap gap-2">
                <div *ngFor="let fileItem of selectedFiles; let i = index"
                     class="badge badge-light-primary d-flex align-items-center gap-2 p-3">
                  <i class="ki-duotone ki-file fs-3">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                  <div class="d-flex flex-column align-items-start">
                    <span class="fs-7 fw-semibold">{{ fileItem.file.name }}</span>
                    <span class="fs-8 text-muted">{{ formatFileSize(fileItem.file.size) }}</span>
                  </div>

                  <!-- Upload Progress -->
                  <span *ngIf="fileItem.uploading" class="spinner-border spinner-border-sm ms-2"></span>

                  <!-- Upload Success -->
                  <i *ngIf="fileItem.uploadedUrl && !fileItem.uploading"
                     class="ki-duotone ki-check-circle fs-3 text-success ms-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>

                  <!-- Upload Error -->
                  <i *ngIf="fileItem.error && !fileItem.uploading"
                     class="ki-duotone ki-cross-circle fs-3 text-danger ms-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>

                  <!-- Remove Button -->
                  <button
                    type="button"
                    class="btn btn-icon btn-sm btn-active-color-primary ms-2"
                    (click)="removeFile(i)"
                    [disabled]="fileItem.uploading">
                    <i class="ki-duotone ki-cross fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </button>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-end gap-3 p-3 border border-2 border-gray-300 rounded bg-light-subtle">
              <!-- File Upload Button -->
              <div>
                <input
                  type="file"
                  #fileInput
                  class="d-none"
                  multiple
                  accept="image/*,.pdf,.doc,.docx"
                  (change)="onFilesSelected($event)">
                <button
                  type="button"
                  class="btn btn-icon btn-light-primary"
                  (click)="fileInput.click()"
                  [disabled]="isSendingMessage || isUploadingAttachments">
                  <i class="ki-duotone ki-file-added fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>
              </div>

              <!-- Message Textarea -->
              <textarea
                class="form-control form-control-solid flex-grow-1 border-0"
                rows="2"
                placeholder="Type your message..."
                [(ngModel)]="newMessage"
                [disabled]="isSendingMessage || isUploadingAttachments"
                (keydown.enter)="$event.preventDefault(); sendMessage()"></textarea>

              <!-- Send Button -->
              <button
                type="button"
                class="btn btn-primary btn-icon"
                (click)="sendMessage()"
                [disabled]="(!newMessage.trim() && selectedFiles.length === 0) || isSendingMessage || isUploadingAttachments">
                <span *ngIf="!isSendingMessage && !isUploadingAttachments">
                  <i class="ki-duotone ki-send fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
                <span *ngIf="isSendingMessage || isUploadingAttachments" class="spinner-border spinner-border-sm"></span>
              </button>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="text-muted fs-8">Press Enter to send</div>
              <div class="text-muted fs-8" *ngIf="isUploadingAttachments">
                <span class="spinner-border spinner-border-sm me-1"></span>
                Uploading attachments...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
